export const getSidebarLabelByValue = (key, data) => {
  for (const item of data) {
    if (item.key === key) {
      return item.label;
    }

    if (item.children && Array.isArray(item.children)) {
      const foundLabel = getSidebarLabelByValue(key, item.children);
      if (foundLabel) {
        return foundLabel;
      }
    }
  }

  return "";
};
